import React from 'react';
import { MessageCircle, Headphones, Phone, Sparkles, Image as ImageIcon, AudioLines, DoorOpen } from 'lucide-react';
import { ROW_KEYS } from './membershipCopy';

export const ROW_ICONS = {
  message: MessageCircle, listen_minutes: Headphones, talk_minutes: Phone, dreams: Sparkles,
  image_creation: ImageIcon, shared_audio: AudioLines, next_room: DoorOpen,
};

const Row = ({ k, testid, muted, children }) => {
  const Icon = ROW_ICONS[k];
  return (
    <li className={`mp-row${muted ? ' mp-row--muted' : ''}`} data-testid={testid}>
      <Icon className="mp-row__icon" aria-hidden="true" />
      <span>{children}</span>
    </li>
  );
};

const NextRoomRow = ({ c, id }) => {
  const testid = `membership-${id}-next-room`;
  if (id === 'meet') return <Row k="next_room" testid={testid}>{c.nextRoomOne}</Row>;
  if (id === 'essential') return <Row k="next_room" testid={testid} muted>— {c.notIncluded.next_room}</Row>;
  return (
    <Row k="next_room" testid={testid}>
      {c.nextRoomIncluded}<span className="mp-row__sub">{c.included}</span>
    </Row>
  );
};

export const MembershipCard = ({ c, id, tier, title, sub, price, per, badge, featured, nf, action, fine }) => (
  <article className={`mp-card${featured ? ' mp-card--featured' : ''}`} data-testid={`membership-card-${id}`}>
    {badge && <span className={`mp-badge${featured ? ' mp-badge--gold' : ''}`} data-testid={`membership-badge-${id}`}>{badge}</span>}
    <h2 className="mp-card__title">{title}</h2>
    {price && (
      <p className="mp-card__price" data-testid={`membership-price-${id}`}>
        {price}<span className="mp-card__per">/{per}</span>
      </p>
    )}
    <p className="mp-card__sub">{sub}</p>
    <ul className="mp-card__rows" aria-label={title}>
      {ROW_KEYS.map((k) => (tier[k] > 0
        ? <Row key={k} k={k} testid={`membership-${id}-${k}`}><strong>{nf.format(tier[k])}</strong> {c.rows[k](tier[k])}</Row>
        : <Row key={k} k={k} testid={`membership-${id}-${k}`} muted>— {c.notIncluded[k] || c.none}</Row>))}
      <NextRoomRow c={c} id={id} />
    </ul>
    <div className="mp-card__foot">
      {action}
      <p className="mp-card__fine" data-testid={`membership-fine-${id}`}>{fine}</p>
    </div>
  </article>
);
